import { z } from 'zod';

export const getInstallationSchema = z.array(
  z.object({
    applicationName: z.string(),
    moduleName: z.string(),
    isEnabled: z.boolean(),
    mwApplicationId: z.string().optional(),
    mwModuleId: z.string().optional(),
    order: z.number().optional(),
  })
);

export type GetInstallationResult = z.infer<typeof getInstallationSchema>;
